import React, { ElementType, useState } from 'react'
import * as S from './index.style'
import TextField from '@material-ui/core/TextField'
import { InputBaseComponentProps } from '@material-ui/core'
import { DadosInfraestrutura, ValidacaoDadosInfraestrutura } from 'models/Viabilidade/Infraestrutura'
import { MascaraDecimal } from 'components/Mascara/Decimal'
import Grid from 'components/Grid'

export type CardInfraestruturaProps = {
  /** Descricao do que a prop faz, vai direto pro storybook */
  dadosInfraestrutura: DadosInfraestrutura
  dadosInfraestruturaHandler: (novoValor: DadosInfraestrutura) => void
}

/** Descricao do que o componente faz, vai direto pro storybook */
const CardInfraestrutura: React.FC<CardInfraestruturaProps> = ({ dadosInfraestrutura, dadosInfraestruturaHandler }) => {
  const [valores, setValores] = useState(dadosInfraestrutura)
  const [mensagensErro, setMensagensErro] = useState(new ValidacaoDadosInfraestrutura())

  const viarioInternoCondominioHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValores({ viarioInternoCondominio: event.target.value, valido: false })
    dadosInfraestruturaHandler({ viarioInternoCondominio: event.target.value, valido: false })
  }

  const validarViarioInternoCondominio = () => {
    const erroViarioInternoCondominio = mensagensErro.validarViarioInternoCondominio(valores.viarioInternoCondominio)

    const validador = new ValidacaoDadosInfraestrutura(erroViarioInternoCondominio)

    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarCard = (validador: ValidacaoDadosInfraestrutura) => {
    const state = { ...valores } as DadosInfraestrutura

    state.valido = validador.validarTodosCampos(state)
    setValores(state)
    dadosInfraestruturaHandler(state)
  }

  return (
    <S.Wrapper>
      <Grid orientacao="column" gridTemplateColumns=".25fr" gridGap="32px">
        <div>
          <S.Label>Viário Interno Condomínio (m²)</S.Label>
          <TextField
            required
            placeholder="00.000,00"
            type="text"
            name="viarioInternoCondominio"
            data-cy="campoViarioInternoCondominio"
            value={valores.viarioInternoCondominio}
            onChange={viarioInternoCondominioHandler}
            onBlur={validarViarioInternoCondominio}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.viarioInternoCondominio != ''}
            helperText={mensagensErro.viarioInternoCondominio}
          />
        </div>
      </Grid>
    </S.Wrapper>
  )
}

export default CardInfraestrutura
